import * as Blockly from 'blockly';

// Store Jinja variable options globally in this module
let jinjaVariableOptions = [['parameter', 'parameter']];

// Register Jinja blocks
export function registerJinjaBlocks(variableOptions = []) {
  // Update the stored options
  jinjaVariableOptions = variableOptions.length > 0 
    ? variableOptions 
    : [['parameter', 'parameter']]; // Default option if none provided
    
  console.log('Updated stored Jinja variable options:', jinjaVariableOptions);

  // Jinja variable block
  Blockly.Blocks['jinja_variable'] = {
    init: function() {
      this.appendDummyInput()
          .appendField("{{ ")
          .appendField(new Blockly.FieldDropdown(jinjaVariableOptions), "VAR")
          .appendField(" }}");
      // Set output to null to allow connection to any type
      this.setOutput(true, null);
      this.setColour(100);
      this.setTooltip("Jinja variable");
      this.setHelpUrl("");
    },
    
    // Add a mutator to handle custom variable names
    mutationToDom: function() {
      const container = document.createElement('mutation');
      const varName = this.getFieldValue('VAR');
      container.setAttribute('var_name', varName);
      
      // Check if this variable is valid
      const isValid = jinjaVariableOptions.some(option => option[0] === varName);
      container.setAttribute('is_valid', isValid.toString());
      
      return container;
    },
    
    domToMutation: function(xmlElement) {
      const varName = xmlElement.getAttribute('var_name');
      const isValid = xmlElement.getAttribute('is_valid') === 'true';
      
      // If invalid, update the block appearance
      if (!isValid && varName) {
        this.setColour(160); // Error color
        this.setWarningText(`Invalid variable: "${varName}". Please select a valid option.`);
        
        // Replace the input with a custom one showing the invalid variable
        this.removeInput(0);
        const input = this.appendDummyInput();
        input.appendField("⚠️ {{ ");
        input.appendField(varName, "INVALID_VAR"); // Show the invalid name as text
        input.appendField(" }}");
        
        // Add a second input with the dropdown for selection
        const selectionInput = this.appendDummyInput();
        selectionInput.appendField("Select valid: ");
        selectionInput.appendField(new Blockly.FieldDropdown(jinjaVariableOptions), "VAR");
      }
    },
    
    // Override onchange to update the block when the dropdown value changes
    onchange: function(event) {
      if (event.type === Blockly.Events.BLOCK_CHANGE &&
          event.blockId === this.id &&
          event.name === 'VAR') {
        
        const varName = this.getFieldValue('VAR');
        const isValid = jinjaVariableOptions.some(option => option[0] === varName);
        
        // Update block appearance based on validity
        if (isValid) {
          this.setColour(100); // Valid color
          this.setWarningText(null);
          
          // If we have multiple inputs (from an invalid state), reset to normal
          if (this.inputList.length > 1) {
            // Remove all inputs and recreate the standard input
            this.inputList.forEach(() => this.removeInput(0));
            const input = this.appendDummyInput();
            input.appendField("{{ ");
            input.appendField(new Blockly.FieldDropdown(jinjaVariableOptions), "VAR");
            input.appendField(" }}");
            
            // Set the selected value
            this.getField('VAR').setValue(varName);
            
            // Reinitialize the block
            this.initSvg();
            this.render();
          }
        }
      }
    }
  };

  // Jinja for-each loop block
  Blockly.Blocks['jinja_for_each'] = {
    init: function() {
      this.appendDummyInput()
          .appendField("{% for item in ")
          .appendField(new Blockly.FieldDropdown(jinjaVariableOptions), "VAR")
          .appendField(" %}");
      this.appendStatementInput("BODY")
          .setCheck(null);
      this.appendDummyInput()
          .appendField("{% endfor %}");
      this.setPreviousStatement(true, null);
      this.setNextStatement(true, null);
      this.setColour(100);
      this.setTooltip("Jinja for-each loop");
      this.setHelpUrl("");
    }
  };

  // Jinja if-equals condition block
  Blockly.Blocks['jinja_if_equals'] = {
    init: function() {
      this.appendDummyInput()
          .appendField("{% if ")
          .appendField(new Blockly.FieldDropdown(jinjaVariableOptions), "VAR")
          .appendField(" == ")
          .appendField(new Blockly.FieldTextInput("value"), "VALUE")
          .appendField(" %}");
      this.appendStatementInput("THEN")
          .setCheck(null);
      this.appendDummyInput()
          .appendField("{% else %}");
      this.appendStatementInput("ELSE")
          .setCheck(null);
      this.appendDummyInput()
          .appendField("{% endif %}");
      this.setPreviousStatement(true, null);
      this.setNextStatement(true, null);
      this.setColour(100);
      this.setTooltip("Jinja if-equals condition");
      this.setHelpUrl("");
    }
  };

  // Jinja if/elsif/else statement block with mutator for dynamic branches
  Blockly.Blocks['jinja_if_statement'] = {
    init: function() {
      this.setColour(100);
      this.appendDummyInput()
          .appendField("{% if ")
          .appendField(new Blockly.FieldTextInput("condition"), "CONDITION")
          .appendField(" %}");
      this.appendStatementInput("IF_BODY")
          .setCheck(null)
          .appendField("then:");
      // this.appendDummyInput()
      //     .appendField("{% endif %}");
      this.setPreviousStatement(true, null);
      this.setNextStatement(true, null);
      // this.setMutator(new Blockly.Mutator(['jinja_elif_item', 'jinja_else_item']));
      this.setTooltip("Jinja if/elsif/else conditional statement with multiple branches");
      this.setHelpUrl("");
      
      // Initialize with no elif/else blocks
      this.elifCount_ = 0;
      this.elseCount_ = 0;
    },

    mutationToDom: function() {
      if (!this.elifCount_ && !this.elseCount_) {
        return null;
      }
      const container = document.createElement('mutation');
      if (this.elifCount_) {
        container.setAttribute('elif', this.elifCount_);
      }
      if (this.elseCount_) {
        container.setAttribute('else', 1);
      }
      return container;
    },

    domToMutation: function(xmlElement) {
      this.elifCount_ = parseInt(xmlElement.getAttribute('elif')) || 0;
      this.elseCount_ = xmlElement.getAttribute('else') ? 1 : 0;
      this.updateShape_();
    },

    decompose: function(workspace) {
      const containerBlock = workspace.newBlock('jinja_if_container');
      containerBlock.initSvg();
      let connection = containerBlock.getInput('STACK').connection;
      
      // Add elif blocks
      for (let i = 0; i < this.elifCount_; i++) {
        const elifBlock = workspace.newBlock('jinja_elif_item');
        elifBlock.initSvg();
        connection.connect(elifBlock.previousConnection);
        connection = elifBlock.nextConnection;
      }
      
      // Add else block
      if (this.elseCount_) {
        const elseBlock = workspace.newBlock('jinja_else_item');
        elseBlock.initSvg();
        connection.connect(elseBlock.previousConnection);
      }
      
      return containerBlock;
    },

    compose: function(containerBlock) {
      // Count elif and else blocks
      let elifBlock = containerBlock.getInputTargetBlock('STACK');
      this.elifCount_ = 0;
      this.elseCount_ = 0;
      
      const connections = [null];
      const elifConditions = [null];
      
      while (elifBlock) {
        switch (elifBlock.type) {
          case 'jinja_elif_item':
            this.elifCount_++;
            connections.push(elifBlock.valueConnection_);
            elifConditions.push(elifBlock.conditionValue_);
            break;
          case 'jinja_else_item':
            this.elseCount_ = 1;
            connections.push(elifBlock.statementConnection_);
            break;
        }
        elifBlock = elifBlock.nextConnection &&
            elifBlock.nextConnection.targetBlock();
      }
      
      this.updateShape_();
      
      // Reconnect any child blocks
      for (let i = 1; i < connections.length; i++) {
        if (connections[i]) {
          if (i <= this.elifCount_) {
            // Reconnect elif body
            if (this.getInput('ELIF_BODY' + (i - 1))) {
              this.getInput('ELIF_BODY' + (i - 1)).connection.connect(connections[i]);
            }
          } else {
            // Reconnect else body
            if (this.getInput('ELSE_BODY')) {
              this.getInput('ELSE_BODY').connection.connect(connections[i]);
            }
          }
        }
      }
      
      // Restore elif conditions
      for (let i = 1; i <= this.elifCount_; i++) {
        if (elifConditions[i] && this.getField('ELIF_CONDITION' + (i - 1))) {
          this.getField('ELIF_CONDITION' + (i - 1)).setValue(elifConditions[i]);
        }
      }
    },

    updateShape_: function() {
      // Remove existing elif and else inputs
      let i = 0;
      while (this.getInput('ELIF_CONDITION' + i)) {
        this.removeInput('ELIF_CONDITION' + i);
        this.removeInput('ELIF_BODY' + i);
        i++;
      }
      if (this.getInput('ELSE_LABEL')) {
        this.removeInput('ELSE_LABEL');
      }
      if (this.getInput('ELSE_BODY')) {
        this.removeInput('ELSE_BODY');
      }
      if (this.getInput('ENDIF_LABEL')) {
        this.removeInput('ENDIF_LABEL');
      }
      
      // Add elif blocks
      for (let i = 0; i < this.elifCount_; i++) {
        this.appendDummyInput('ELIF_CONDITION' + i)
            .appendField("{% elif ")
            .appendField(new Blockly.FieldTextInput("condition"), "ELIF_CONDITION" + i)
            .appendField(" %}");
        this.appendStatementInput('ELIF_BODY' + i)
            .setCheck(null)
            .appendField("then:");
      }
      
      // Add else block
      if (this.elseCount_) {
        this.appendDummyInput('ELSE_LABEL')
            .appendField("{% else %}");
        this.appendStatementInput('ELSE_BODY')
            .setCheck(null)
            .appendField("else:");
      }
      
      // Always end with endif
      this.appendDummyInput('ENDIF_LABEL')
          .appendField("{% endif %}");
    },

    saveConnections: function(containerBlock) {
      // Save connections for elif blocks
      let elifBlock = containerBlock.getInputTargetBlock('STACK');
      let i = 0;
      while (elifBlock) {
        switch (elifBlock.type) {
          case 'jinja_elif_item':
            const elifInput = this.getInput('ELIF_BODY' + i);
            elifBlock.statementConnection_ = elifInput && elifInput.connection.targetConnection;
            const elifField = this.getField('ELIF_CONDITION' + i);
            elifBlock.conditionValue_ = elifField && elifField.getValue();
            i++;
            break;
          case 'jinja_else_item':
            const elseInput = this.getInput('ELSE_BODY');
            elifBlock.statementConnection_ = elseInput && elseInput.connection.targetConnection;
            break;
        }
        elifBlock = elifBlock.nextConnection && elifBlock.nextConnection.targetBlock();
      }
    }
  };

  // Mutator helper blocks for if statement
  Blockly.Blocks['jinja_if_container'] = {
    init: function() {
      this.setColour(100);
      this.appendDummyInput()
          .appendField("if statement");
      this.appendStatementInput('STACK');
      this.setTooltip("Add elif and else branches to the if statement");
      this.contextMenu = false;
    }
  };

  Blockly.Blocks['jinja_elif_item'] = {
    init: function() {
      this.setColour(100);
      this.appendDummyInput()
          .appendField("elif");
      this.setPreviousStatement(true);
      this.setNextStatement(true);
      this.setTooltip("Add an elif branch");
      this.contextMenu = false;
    }
  };

  Blockly.Blocks['jinja_else_item'] = {
    init: function() {
      this.setColour(100);
      this.appendDummyInput()
          .appendField("else");
      this.setPreviousStatement(true);
      this.setTooltip("Add an else branch");
      this.contextMenu = false;
    }
  };

  // Jinja if/elsif/else statement block with mutator for dynamic branches (nested version without endif)
  Blockly.Blocks['jinja_if_statement_nested'] = {
    init: function() {
      this.setColour(100);
      this.appendDummyInput()
          .appendField("{% if ")
          .appendField(new Blockly.FieldTextInput("condition"), "CONDITION")
          .appendField(" %}");
      this.appendStatementInput("IF_BODY")
          .setCheck(null)
          .appendField("then:");
      // Note: No endif for nested blocks
      this.setPreviousStatement(true, null);
      this.setNextStatement(true, null);
      this.setTooltip("Nested Jinja if/elsif/else conditional statement (no endif)");
      this.setHelpUrl("");
      
      // Initialize with no elif/else blocks
      this.elifCount_ = 0;
      this.elseCount_ = 0;
    },

    mutationToDom: function() {
      if (!this.elifCount_ && !this.elseCount_) {
        return null;
      }
      const container = document.createElement('mutation');
      if (this.elifCount_) {
        container.setAttribute('elif', this.elifCount_);
      }
      if (this.elseCount_) {
        container.setAttribute('else', 1);
      }
      return container;
    },

    domToMutation: function(xmlElement) {
      this.elifCount_ = parseInt(xmlElement.getAttribute('elif')) || 0;
      this.elseCount_ = xmlElement.getAttribute('else') ? 1 : 0;
      this.updateShape_();
    },

    updateShape_: function() {
      // Remove existing elif and else inputs
      let i = 0;
      while (this.getInput('ELIF_CONDITION' + i)) {
        this.removeInput('ELIF_CONDITION' + i);
        this.removeInput('ELIF_BODY' + i);
        i++;
      }
      if (this.getInput('ELSE_LABEL')) {
        this.removeInput('ELSE_LABEL');
      }
      if (this.getInput('ELSE_BODY')) {
        this.removeInput('ELSE_BODY');
      }
      
      // Add elif blocks
      for (let i = 0; i < this.elifCount_; i++) {
        this.appendDummyInput('ELIF_CONDITION' + i)
            .appendField("{% elif ")
            .appendField(new Blockly.FieldTextInput("condition"), "ELIF_CONDITION" + i)
            .appendField(" %}");
        this.appendStatementInput('ELIF_BODY' + i)
            .setCheck(null)
            .appendField("then:");
      }
      
      // Add else block
      if (this.elseCount_) {
        this.appendDummyInput('ELSE_LABEL')
            .appendField("{% else %}");
        this.appendStatementInput('ELSE_BODY')
            .setCheck(null)
            .appendField("else:");
      }
      
      // Note: No endif label for nested blocks
    }
  };

  console.log('Registered Jinja blocks with options:', jinjaVariableOptions);
}

// Create a Jinja variable block with a specific variable name
export function createJinjaVariableBlock(workspace, varName) {
  if (!workspace || !varName) {
    console.error('Invalid workspace or variable name');
    return null;
  }
  
  console.log(`Creating Jinja variable block for: ${varName}`);
  
  // Check if the variable is valid
  const isValid = jinjaVariableOptions.some(option => option[0] === varName);
  console.log(`Variable ${varName} is ${isValid ? 'valid' : 'invalid'}`);
  
  if (isValid) {
    // Create a normal Jinja variable block for valid variables
    const block = workspace.newBlock('jinja_variable');
    
    // Set the variable name
    if (block.getField('VAR')) {
      try {
        block.getField('VAR').setValue(varName);
      } catch (e) {
        console.warn(`Could not set field value to ${varName}`, e);
      }
    }
    
    block.initSvg();
    block.render();
    return block;
  } else {
    // For invalid variables, create an invalid value block
    try {
      // Try to use the common invalid value block
      const invalidBlockType = 'common_value_invalid';
      if (Blockly.Blocks[invalidBlockType]) {
        const block = workspace.newBlock(invalidBlockType);
        block.setFieldValue(`{{ ${varName} }}`, 'VALUE');
        block.initSvg();
        block.render();
        return block;
      } else {
        // Fall back to OpenFOAM invalid value block if common one doesn't exist
        const openfoamInvalidBlockType = 'common_value_invalid';
        if (Blockly.Blocks[openfoamInvalidBlockType]) {
          const block = workspace.newBlock(openfoamInvalidBlockType);
          block.setFieldValue(`{{ ${varName} }}`, 'VALUE');
          block.initSvg();
          block.render();
          return block;
        } else {
          // Last resort: use a standard Jinja variable block but mark it as invalid
          console.warn(`Invalid value blocks not found, falling back to standard block for ${varName}`);
          const block = workspace.newBlock('jinja_variable');
          
          // Try to set the field value to the first option
          if (block.getField('VAR') && jinjaVariableOptions.length > 0) {
            block.getField('VAR').setValue(jinjaVariableOptions[0][0]);
          }
          
          // Set warning and color to indicate error
          block.setWarningText(`Invalid variable: "${varName}". Please select a valid option.`);
          block.setColour('#FF6B6B'); // Error color
          
          block.initSvg();
          block.render();
          return block;
        }
      }
    } catch (error) {
      console.error('Error creating invalid value block:', error);
      return null;
    }
  }
}

// Get current Jinja variable options
export function getJinjaVariableOptions() {
  return jinjaVariableOptions;
}

// Update Jinja variable options and refresh existing blocks
export function updateJinjaVariableOptions(newOptions) {
  if (!newOptions || !Array.isArray(newOptions)) {
    console.error('Invalid options provided to updateJinjaVariableOptions');
    return;
  }
  
  // Update stored options
  jinjaVariableOptions = newOptions.length > 0 
    ? newOptions 
    : [['parameter', 'parameter']];
  
  console.log('Updated Jinja variable options:', jinjaVariableOptions);
  
  // Re-register blocks with new options
  registerJinjaBlocks(jinjaVariableOptions);
}

// Generate Jinja toolbox XML
export function generateJinjaToolbox(variableOptions = []) {
  // Update stored options if provided
  if (variableOptions.length > 0) {
    jinjaVariableOptions = variableOptions;
  }

  let toolboxXml = '<xml>';
  
  // Add Jinja variable block
  toolboxXml += `
    <block type="jinja_variable">
      <field name="VAR">${jinjaVariableOptions[0][0]}</field>
    </block>`;
  
  // Add Jinja if/elsif/else statement block
  toolboxXml += `
    <block type="jinja_if_statement">
      <field name="CONDITION">condition</field>
    </block>`;
  
  // Add Jinja nested if statement block (without endif)
  toolboxXml += `
    <block type="jinja_if_statement_nested">
      <field name="CONDITION">condition</field>
    </block>`;
  
  // Add Jinja for-each loop block
  toolboxXml += `
    <block type="jinja_for_each">
      <field name="VAR">${jinjaVariableOptions[0][0]}</field>
    </block>`;
  
  // Add Jinja if-equals condition block (legacy)
  toolboxXml += `
    <block type="jinja_if_equals">
      <field name="VAR">${jinjaVariableOptions[0][0]}</field>
      <field name="VALUE">value</field>
    </block>`;
  
  toolboxXml += '</xml>';
  
  return toolboxXml;
}

// Update toolbox XML with Jinja blocks
export function updateToolboxWithJinjaBlocks(toolboxXml, variableOptions = []) {
  // Update stored options if provided
  if (variableOptions.length > 0) {
    jinjaVariableOptions = variableOptions;
  }

  let toolboxDoc;
  const parser = new DOMParser();

  // Parse input toolbox XML
  try {
    toolboxDoc = parser.parseFromString(toolboxXml, 'text/xml');
    if (toolboxDoc.documentElement.nodeName === 'parsererror') {
      throw new Error('Invalid input toolbox XML');
    }
  } catch (err) {
    console.error('Failed to parse input toolbox XML:', err);
    toolboxDoc = parser.parseFromString('<xml></xml>', 'text/xml');
  }

  // Add static Jinja blocks
  ['jinja_variable', 'jinja_if_statement', 'jinja_if_statement_nested', 'jinja_for_each', 'jinja_if_equals'].forEach((blockType) => {
    const block = toolboxDoc.createElement('block');
    block.setAttribute('type', blockType);
    
    // Add field with default value
    if (blockType === 'jinja_variable' || blockType === 'jinja_for_each') {
      const field = toolboxDoc.createElement('field');
      field.setAttribute('name', 'VAR');
      field.textContent = jinjaVariableOptions[0][0];
      block.appendChild(field);
    }
    
    // Add condition field for if statement blocks
    if (blockType === 'jinja_if_statement' || blockType === 'jinja_if_statement_nested') {
      const conditionField = toolboxDoc.createElement('field');
      conditionField.setAttribute('name', 'CONDITION');
      conditionField.textContent = 'condition';
      block.appendChild(conditionField);
    }
    
    // Add fields for if-equals block
    if (blockType === 'jinja_if_equals') {
      const varField = toolboxDoc.createElement('field');
      varField.setAttribute('name', 'VAR');
      varField.textContent = jinjaVariableOptions[0][0];
      block.appendChild(varField);
      
      const valueField = toolboxDoc.createElement('field');
      valueField.setAttribute('name', 'VALUE');
      valueField.textContent = 'value';
      block.appendChild(valueField);
    }
    
    toolboxDoc.documentElement.appendChild(block);
  });

  // Serialize updated toolbox XML
  const updatedXml = new XMLSerializer().serializeToString(toolboxDoc);
  console.log('Updated toolbox XML with Jinja blocks:', updatedXml);
  return updatedXml;
}
